let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4cD0Q")).then(() => parcelRequire('abGcO'));